export var StashDeviationElementPlacement = /*#__PURE__*/ function(StashDeviationElementPlacement) {
    /**
   * Where all the action happens. The bar directly under the deviation
   */ StashDeviationElementPlacement["PrimaryBar"] = "primary-bar";
    /**
   * Collapsed into the primary bar's more actions menu
   */ StashDeviationElementPlacement["PrimaryBarMenu"] = "primary-bar-menu";
    /**
   * Completely excluded. Nothing. Nowhere.
   */ StashDeviationElementPlacement["NotIncluded"] = "not-included";
    return StashDeviationElementPlacement;
}({});
export const NOT_INCLUDED_VISIBILITY_GROUP = {
    groupPlacement: "not-included",
    countOnBar: 0
};

//# sourceMappingURL=types.js.map